<template>
  <div>
    <!--  搜索添加用户组件-->
    <el-dialog
      :title="$t('common.searchUser')"
      :visible.sync="dialogVisible"
      width="50%"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <!--  搜索条件-->
      <div>
        <el-form
          :inline="true"
          ref="searchData"
          :model="searchData"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item :label="$t('common.name') + ':'" width="20px">
            <el-input
              v-model="searchData.name"
              :placeholder="$t('common.pleaseInputValue')"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.jigou') + ':'" width="20px">
            <el-input
              v-model="searchData.orgName"
              :placeholder="$t('common.pleaseInputValue')"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.account') + ':'" width="20px">
            <el-input
              v-model="searchData.account"
              :placeholder="$t('common.pleaseInputValue')"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.registerEmail') + ':'" width="20px">
            <el-input
              v-model="searchData.email"
              :placeholder="$t('common.pleaseInputValue')"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.registerPhone') + ':'" width="20px">
            <el-input
              v-model="searchData.phone"
              :placeholder="$t('common.pleaseInputValue')"
              style="width: 190px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getUserList">{{
              $t("common.search")
            }}</el-button>
            <el-button type="primary" @click="resetForm">{{
              $t("common.reset")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--  表格-->
      <div style="max-height: 400px; overflow: auto">
        <el-table
          :data="tablelist"
          :empty-text="$t('common.noData')"
          style="width: 100%"
        >
          <el-table-column prop="name" :label="$t('common.name')" width="180">
          </el-table-column>
          <el-table-column
            prop="orgName"
            :label="$t('common.jigou')"
            width="180"
          >
          </el-table-column>
          <el-table-column prop="email" :label="$t('common.registerEmail')">
          </el-table-column>
          <el-table-column prop="phone" :label="$t('common.registerPhone')">
          </el-table-column>
          <el-table-column :label="$t('common.handle')">
            <template slot-scope="scope">
              <span class="blueSpan" @click="addUserFunc(scope.row)">{{
                $t("common.add")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  分页-->
      <el-pagination
        v-if="tablelist.length > 0"
        background
        size="min"
        layout="prev, pager, next"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        :hide-on-single-page="false"
        :total="totalCount"
      >
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("common.cancelSpace")
        }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("common.trueText")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["roleCodeArr"],
  data() {
    return {
      type: "", //author contact
      dialogVisible: false,
      searchData: {
        name: "",
        orgName: "",
        account: "",
        email: "",
        phone: "",
      },
      tablelist: [
        // { userId:"1234" ,userName: "王晓丽", orgCode: "0187103",orgName: "机构1", email:"211212@164.com" ,phone:'183929292121'},
      ],
      // 分页
      pageNo: 1,
      pageSize: 10,
      totalCount: 10,
    };
  },
  mounted() {},
  methods: {
    getUserList() {
      let data = {
        account: this.searchData.account,
        email: this.searchData.email,
        name: this.searchData.name,
        phone: this.searchData.phone,
        orgName: this.searchData.orgName,
        meetingCode: this.$store.state.dict.currentMeetingCode,
        roleCodeArr: this.roleCodeArr,
        page: this.pageNo,
        rows: this.pageSize,
      };
      console.log(data)
      this.$api.getUserList(data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.tablelist = res.data.records;
          this.pageNo = res.data.current;
          this.totalCount = res.data.total;
        }
      });
    },
    //初始化弹出列表
    handleOpen(type) {
      this.type = type;
      this.dialogVisible = true;
      this.resetForm();
      this.tablelist = [];
      this.pageNo = 1;
      this.totalCount = 10;
    },
    handleClose(done) {
      done();
    },
    resetForm() {
      this.searchData = {
        name: "",
        orgName: "",
        account: "",
        email: "",
        phone: "",
      };
    },
    addUserFunc(row) {
      let data = {};
      data.userId = row.userId;
      data.userName = row.name;
      data.orgCode = row.orgCode;
      data.orgName = row.orgName;
      data.email = row.email;
      data.phone = row.phone;
      this.$emit("addUserFunc", data, this.type);
    },
    //分页查询
    handleCurrentChange() {
      console.log(this.pageNo);
      this.getUserList();
    },
  },
};
</script>

<style scoped>
</style>
